import styled from "@emotion/styled";

export const LongCardImage = styled.img`
  margin-top: 20px;
  max-width: 360px;
  width: 100%;
  height: 100%;
  border-radius: 16px;
`;
